// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"666":"811fcca6","750":"d3d80b0c","838":"a0b218b9","998":"f589d148"}[chunkId] + ".chunk.js";
};